import $ from 'jquery';

$(function() {

    initProfitCalculator();

});


function initProfitCalculator() {

    $('#calculate-profit').unbind('click');
    $('#calculate-profit').on('click', function() {

        let servingSize = $('#serving-size').val();
        let incVat = $('#price-vat').val();
        let servingPrice = parseFloat($('#serving-price').val());
        let productVolume = parseFloat($('#product-volume').val());
        let productPrice = parseFloat($('#product-price').val());

        $('#serving-price').val(servingPrice.toFixed(2));

        if (!servingSize || !incVat || !servingPrice || !productVolume || !productPrice) {
            console.log('missing parameters');
            $('.profit-result').removeClass('show');
            $('#profit').val('');
            return;
        }

        // console.log('Serving size: ' + servingSize);
        // console.log('Inc VAT: ' + incVat);
        // console.log('Serving price: ' + servingPrice);
        // console.log('Product volume: ' + productVolume);
        // console.log('Product price: ' + productPrice);

        let costPerUnitExVat = (productPrice / ((productVolume * 1000) / servingSize));
        let costPerUnitIncVat = (costPerUnitExVat * 1.2);

        let profit = 0;
        if (incVat === 'inc') {
            profit = (servingPrice - costPerUnitIncVat);
        } else {
            profit = (servingPrice - costPerUnitExVat);
        }
        profit = profit.toFixed(2);
        $('#profit').text(profit);
        $('.profit-result').addClass('show');

        // console.log('Cost per unit: ' + costPerUnitExVat);

    });

}
